import "./Policy.css";

function Terms() {
  return (
    <div className="lp-page">

      <div className="lp-hero">
        <div className="lp-hero-tag">📄 Legal</div>
        <h1>Terms & Conditions</h1>
        <p>Please read these terms carefully before using Learnlia.</p>
      </div>

      <div className="lp-container">
        <div className="lp-meta">
          <span>Last updated: March 2025</span>
          <span className="lp-meta-dot" />
          <span>Learnlia</span>
        </div>

        <div className="lp-section">
          <h2>Acceptance of Terms</h2>
          <p>
            By accessing or using Learnlia, you agree to be bound by these
            Terms & Conditions. If you do not agree, please do not use the platform.
          </p>
        </div>

        <div className="lp-section">
          <h2>Use of Service</h2>
          <p>
            Learnlia is intended for personal educational use. You agree to use the platform
            only for lawful purposes and in a manner that does not infringe the rights of others.
          </p>
          <ul>
            <li>Do not attempt to reverse-engineer or exploit the platform</li>
            <li>Do not use automated tools to scrape or abuse the service</li>
            <li>Do not share your account credentials with others</li>
          </ul>
        </div>

        <div className="lp-section">
          <h2>Account Responsibility</h2>
          <p>
            You are responsible for maintaining the confidentiality of your login credentials
            and for all activity that occurs under your account. Notify us immediately if you
            suspect unauthorized access.
          </p>
        </div>

        <div className="lp-section">
          <h2>Content Disclaimer</h2>
          <p>
            Learnlia does not own, host, or distribute YouTube content. We provide a structured
            layer on top of publicly available playlists to help you track your learning.
            All video content remains the property of its respective creators and is subject
            to YouTube's terms of service.
          </p>
          <div className="lp-callout">
            <strong>Note:</strong> Learnlia does not download or store any YouTube videos.
            All playback happens directly through the YouTube embedded player.
          </div>
        </div>

        <div className="lp-section">
          <h2>Intellectual Property</h2>
          <p>
            The Learnlia platform, including its design, code, and branding, is the intellectual
            property of Learnlia. You may not copy, reproduce, or distribute any part of it
            without written permission.
          </p>
        </div>

        <div className="lp-section">
          <h2>Termination</h2>
          <p>
            We reserve the right to suspend or terminate accounts that violate these terms,
            engage in abuse, or are found to be using the platform fraudulently.
          </p>
        </div>

        <div className="lp-section">
          <h2>Changes to Terms</h2>
          <p>
            Learnlia may update these terms from time to time. Continued use of the platform
            after changes are published constitutes acceptance of the new terms.
          </p>
        </div>

        <div className="lp-section">
          <h2>Contact</h2>
          <p>
            If you have questions about these terms, reach us at{" "}
            <a href="mailto:learnliadev@gmail.com" style={{ color: "var(--accent)" }}>
              learnliadev@gmail.com
            </a>
          </p>
        </div>

      </div>
    </div>
  );
}

export default Terms;